import {IsomorphicScript} from '@aboutyou/head-elements';
import React, {useEffect, useState} from 'react';
import {CheckoutTrackingEvent} from './mapCheckoutTrackingEvent';

export const CHECKOUT_TRACKING_EVENT = 'CHECKOUT_TRACKING_EVENT';

export const dispatchCheckoutTrackingEvent = (event: CheckoutTrackingEvent) => {
  window.dispatchEvent(
    new CustomEvent(CHECKOUT_TRACKING_EVENT, {detail: event}),
  );
};

let initialized = false;
export const CheckoutTrackingListener = ({
  isServerRendered,
}: {
  isServerRendered: boolean;
}) => {
  const [isListenerReady] = useState(() => initialized);

  useEffect(() => {
    initialized = true;
  }, []);

  if (isListenerReady) {
    return null;
  }

  if (isServerRendered) {
    return (
      <script
        id="checkout-tracking-listener"
        type="module"
        dangerouslySetInnerHTML={{__html: `(${initializeScript.toString()})()`}}
      />
    );
  }

  return (
    <IsomorphicScript
      id="checkout-tracking-listener"
      content={`(${initializeScript.toString()})()`}
    />
  );
};

const initializeScript = () => {
  const RETRY_DELAY_MS = 30;
  const tryAttach = () => {
    if (!window.scayleCheckoutEvents) {
      setTimeout(tryAttach, RETRY_DELAY_MS);
      return;
    }
    window.scayleCheckoutEvents.addEventListener('track', event => {
      if (!(event instanceof CustomEvent)) {
        return;
      }
      window.dispatchEvent(new CustomEvent('CHECKOUT_TRACKING_EVENT', event));
    });
  };

  tryAttach();
};
